import * as ko from 'knockout';
import {IMessageData, TBaseOrObservableType} from '../../index';
import multiHtml from './multi.html?raw';

export const template = multiHtml;

/** Default number of items shown before "show more" when collapse is enabled. */
export const MULTI_COLLAPSE_DEFAULT = 10;

export class MultiComponent<T = any> {
    public data!: TBaseOrObservableType<T[]>;
    public isReady!: KnockoutObservable<boolean>;
    public messageData!: KnockoutObservable<IMessageData>;
    public cssClass!: TBaseOrObservableType<string>;
    /** When set, only this many items show until the user expands via show more. */
    public initialVisible?: number;
    public readonly visibleCount = ko.observable(0);

    readonly visibleItems = ko.pureComputed((): T[] => {
        const all = (ko.unwrap(this.data) ?? []) as T[];
        if (!this.initialVisible) {
            return all;
        }
        return all.slice(0, this.visibleCount());
    });

    /** Call after assigning `data` to collapse long lists behind "show more". */
    enableCollapse(limit = MULTI_COLLAPSE_DEFAULT): this {
        this.initialVisible = limit;
        this.visibleCount(limit);
        return this;
    }
}
